export const formatNumberToDecimal = (num: number) => {
  return num % 1 === 0 ? num.toFixed(1) : num.toString();
};
